import { authApiClient } from "./apiClient";
import { Route, Transport } from "../types/Route";

export const addRoute = async (routeData: Route): Promise<any> => {
  const response = await authApiClient.post("/routes/add", routeData);
  return response.data;
};

export const fetchProviders = async (): Promise<Transport[]> => {
  const response = await authApiClient.get("/routes/providers");
  return response.data.providers;
};

export const fetchRequesters = async (): Promise<Transport[]> => {
  const response = await authApiClient.get("/routes/requesters");
  return response.data.requesters;
};
